package com.eladfinish.bible.contest.common.usecases

import androidx.compose.ui.text.TextRange
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.extensions.end
import com.eladfinish.bible.contest.extensions.start

class GetHighlightedVerseMarkupRangeUseCase(
    private val getContentOfChapterUseCase: GetContentOfChapterUseCase,
) {

    operator fun invoke(
        bookIndex: Int,
        chapter: String,
        otVerse: String? = null,
        onlyQri: Boolean = true,
    ): Pair<String, TextRange> {
        val onlyContent = getContentOfChapterUseCase(
            bookIndex = bookIndex,
            chapter = chapter,
            onlyQri = onlyQri,
        )
        return onlyContent to computeVerseRange(onlyContent = onlyContent, otVerse = otVerse)
    }

    companion object {
        /**
         * Finds the [TextRange] of the verse [otVerse] inside [onlyContent].
         *
         * The ot-pasuk is followed by a NO-BREAK SPACE in displayed content (see
         * replaceSpaceWithNoBreakSpace). `\s` matches NBSP on Android's ICU regex but NOT on
         * Kotlin/Native (iOS) or OpenJDK, so the whitespace class must include NBSP explicitly —
         * otherwise the drawn verse is never matched on iOS and gets no highlight.
         */
        internal fun computeVerseRange(onlyContent: String, otVerse: String?): TextRange {
            var start = 0
            var end = 0
            val ws = "[\\s${StringConstants.NO_BREAK_SPACE}]"
            val verseWithOtPasuk =
                "${StringConstants.COLON_SPLITTER}$ws$otVerse$ws.*?${StringConstants.COLON_SPLITTER}"

            val matchResult = verseWithOtPasuk.toRegex().find(onlyContent)
            if (matchResult != null) {
                start = matchResult.start + 2 // skip colonSplitter and space
                end = matchResult.end
            } else if (otVerse == "א") {
                end = onlyContent.indexOf(StringConstants.COLON_SPLITTER)
            }
            if (otVerse.isNullOrEmpty()) {
                start = 0
                end = 0
            }
            return TextRange(
                start = start.coerceIn(0, onlyContent.length),
                end = end.coerceIn(0, onlyContent.length),
            )
        }
    }

}
